import React, { useEffect, useState } from 'react';
import { Table } from '@convertlab/cl-design';
const pathPrefix = process.env.DOC_PREFIX || ''

const DataTable = (props) => {
  const { columns, refs, fields, ...restProps } = props
  const [dataSource, setDataSource] = useState([])

  const renderFields = (fields) => {
    if (!Array.isArray(fields)) {
      return []
    }

    return fields.map(async (field) => {
      const data = {}
      if ('fields' in field) {
        data.children = await Promise.all(renderFields(field.fields))
      }
      if ('refs' in field) {
        const refsData = await Promise.all(await renderRefs(field.refs))
        data.children = data.children ? [...data.children, ...refsData] : refsData
      }
      return { ...field, ...data }
    })
  }

  const renderRefs = async (refs) => {
    if (!Array.isArray(refs)) {
      return []
    }

    const refPromises = refs.map((ref) => fetch(`${pathPrefix}${ref}`).then(value => value.json()))

    const refData = await Promise.all(refPromises)

    return renderFields(refData.flat());
  }

  useEffect(() => {
    async function fetchData() {
      const fieldData = await Promise.all(renderFields(fields));
      const refData = await Promise.all(await renderRefs(refs));

      setDataSource([...fieldData, ...refData])
    }

    fetchData()
  }, [])

  return (
    <Table
      rowKey="name"
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      {...restProps}
    />
  )
}

export default DataTable
